import React from 'react';
import { Icon } from '@mui/material';
import MDSnackbar from '../../molecules/MDSnackbar';
import { useNotification } from '../../../../../application/hooks/useNotification';
import { NotificationType } from '../../../../../application/context/NotificationContext';
import { formatRelativeTime } from '../../../../utils/dateUtils';

const GlobalSnackbar: React.FC = () => {
  const { notifications, removeNotification } = useNotification();

  // Get the most recent notification to display
  const currentNotification = notifications[0];

  if (!currentNotification) {
    return null;
  }

  const getIcon = (type: NotificationType) => {
    switch (type) {
      case 'success':
        return <Icon>check</Icon>;
      case 'error':
        return <Icon>error</Icon>;
      case 'warning':
        return <Icon>warning</Icon>;
      case 'info':
        return <Icon>info</Icon>;
      default:
        return <Icon>notifications</Icon>;
    }
  };


  return (
    <MDSnackbar
      open={true}
      color={currentNotification.type}
      icon={getIcon(currentNotification.type)}
      title={currentNotification.title}
      dateTime={formatRelativeTime(currentNotification.timestamp)}
      content={currentNotification.message}
      close={() => removeNotification(currentNotification.id)}
      bgWhite={false}
    />
  );
};

export default GlobalSnackbar;